export default {
  Env: process.env.NODE_ENV,
  Region: process.env.VUE_APP_COGNITO_REGION,
  UserPoolId: process.env.VUE_APP_COGNITO_USERPOOLID,
  ClientId: process.env.VUE_APP_COGNITO_CLIENTID,
  IdentityPoolId: process.env.VUE_APP_COGNITO_INDENTITYPOOLID,
  Bucket: process.env.VUE_APP_BUCKET,
  BucketRegion: process.env.VUE_APP_BUCKET_REGION,
  CommonApiUrl: process.env.VUE_APP_BASE_COMMON_API_URL,
  InventoryApiUrl: process.env.VUE_APP_BASE_INVENTORY_API_URL,
  BucketHost: process.env.VUE_APP_BUCKET_HOST,
  GMOMemberEdit: process.env.VUE_APP_CARD_EDIT,
  ApiMaxRecords: 1000,
  ProjectKind: {
    STANDARD: 'standard',
    MYORIDGE: 'myoridge',
  },
  CalendarDisplayMonth: [
    { value: 1, name: '1月' },
    { value: 2, name: '2月' },
    { value: 3, name: '3月' },
    { value: 4, name: '4月' },
    { value: 5, name: '5月' },
    { value: 6, name: '6月' },
    { value: 7, name: '7月' },
    { value: 8, name: '8月' },
    { value: 9, name: '9月' },
    { value: 10, name: '10月' },
    { value: 11, name: '11月' },
    { value: 12, name: '12月' },
  ],
  CalendarDisplayMonthDefaultIndex: 0,
  CalendarDisplayDayOfWeek: [
    { value: 6, name: '土曜日' },
    { value: 0, name: '日曜日' },
    { value: 1, name: '月曜日' },
  ],
  CalendarDisplayDayOfWeekDefaultIndex: 1,
  BusinessFormDetailKeys: {
    OrderNo: 'orderno',
    EstimateNo: 'estimateno',
    DispatchNo: 'dispatchno',
    ShipmentNo: 'shipmentno',
    DeliveryDate: 'delivery_date',
    ProductCode: 'productcode',
    ProductName: 'productname',
    FigureNo: 'figureno',
    Quantity: 'quantity',
    Unit: 'unit',
    Note: 'note',
    UnitPrice: 'unitprice',
    Price: 'price',
  },
  ScreenUrl: {
    // 注意：ヘッダーで現在表示しているページを判定するため、ファイル名まで確実に明記ください（"index.html"を省略しないでください）。

    // for scheduler-base repository

    // 会員登録
    signup:
      process.env.NODE_ENV !== 'development'
        ? '/base/auth/signup.html'
        : '/auth/signup.html',
    // ログイン
    login:
      process.env.NODE_ENV !== 'development'
        ? '/base/auth/login.html'
        : '/auth/login.html',
    // トップメニュー
    menu:
      process.env.NODE_ENV !== 'development'
        ? '/base/menu/index.html'
        : '/menu/index.html',
    // リダイレクト
    redirect:
      process.env.NODE_ENV !== 'development'
        ? '/base/redirect/index.html'
        : '/redirect/index.html',
    // 連携選択
    ediRedirect:
      process.env.NODE_ENV !== 'development'
        ? '/base/auth/edi.html'
        : '/auth/edi.html',
    // 取引先一覧
    partnerList:
      process.env.NODE_ENV !== 'development'
        ? '/base/partner/index.html'
        : '/partner/index.html',
    // 連携登録
    ediApprove:
      process.env.NODE_ENV !== 'development'
        ? '/base/partner/edi.html'
        : '/partner/edi.html',
    // 文言カスタマイズ
    companyTranslation:
      process.env.NODE_ENV !== 'development'
        ? '/base/company-translation/index.html'
        : '/company-translation/index.html',
    // カスタムレイアウト
    customForm:
      process.env.NODE_ENV !== 'development'
        ? '/base/custom-form/index.html'
        : '/custom-form/index.html',
    // 会社
    company:
      process.env.NODE_ENV !== 'development'
        ? '/base/company/index.html'
        : '/company/index.html',
    // 工場
    factory:
      process.env.NODE_ENV !== 'development'
        ? '/base/factory/index.html'
        : '/factory/index.html',
    // 部署
    department:
      process.env.NODE_ENV !== 'development'
        ? '/base/department/index.html'
        : '/department/index.html',
    // 置き場
    space:
      process.env.NODE_ENV !== 'development'
        ? '/base/space/index.html'
        : '/space/index.html',
    // 棚番
    box:
      process.env.NODE_ENV !== 'development'
        ? '/base/box/index.html'
        : '/box/index.html',
    // 取引先
    partner:
      process.env.NODE_ENV !== 'development'
        ? '/base/partner/index.html'
        : '/partner/index.html',
    // 工程
    facility:
      process.env.NODE_ENV !== 'development'
        ? '/base/facility/index.html'
        : '/facility/index.html',
    // 担当者
    user:
      process.env.NODE_ENV !== 'development'
        ? '/base/user/index.html'
        : '/user/index.html',
    // 工程ボード
    boardInHouse:
      process.env.NODE_ENV !== 'development'
        ? '/base/board/in-house.html'
        : '/board/in-house.html',
    // 製品
    product:
      process.env.NODE_ENV !== 'development'
        ? '/base/product/index.html'
        : '/product/index.html',
    // 製品取込み
    productImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/product-import/index.html'
        : '/product-import/index.html',
    // 製品工程
    productProcessImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/product-process-import/index.html'
        : '/product-process-import/index.html',
    // 構成部品
    structureImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/structure-import/index.html'
        : '/structure-import/index.html',
    // 製品置場
    inventoryImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/inventory-import/index.html'
        : '/inventory-import/index.html',
    // 案件
    projectImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/project-import/index.html'
        : '/project-import/index.html',
    // 受注
    orderImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/order-import/index.html'
        : '/order-import/index.html',
    // 出庫計画
    shipImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/ship-import/index.html'
        : '/ship-import/index.html',
    // 出庫実績
    shipDeliverImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/ship-deliver-import/index.html'
        : '/ship-deliver-import/index.html',
    // 入庫計画
    supplyExtraImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/supply-extra-import/index.html'
        : '/supply-extra-import/index.html',
    // 入庫実績
    supplyDeliverImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/supply-deliver-import/index.html'
        : '/supply-deliver-import/index.html',
    // 棚卸在庫
    lotImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/lot-import/index.html'
        : '/lot-import/index.html',
    partnerImport:
      process.env.NODE_ENV !== 'development'
        ? '/base/partner-import/index.html'
        : '/partner-import/index.html',
    // データ一覧
    import:
      process.env.NODE_ENV !== 'development'
        ? '/base/import/index.html'
        : '/import/index.html',
    // 各種設定
    settingMenu:
      process.env.NODE_ENV !== 'development'
        ? '/base/setting-menu/index.html'
        : '/setting-menu/index.html',

    // for scheduler-purchase repository

    // 受注一覧
    purchaseOrderList:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/order/index.html'
        : '/order/index.html',
    // 発注/受入一覧
    purchaseList:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/purchase/index.html'
        : '/purchase/index.html',
    // 見積依頼書印刷
    estimateRequestPrint:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/purchase/estimate_request_print.html'
        : '/purchase/estimate_request_print.html',
    // 納品一覧
    shipmentList:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/shipment/index.html'
        : '/shipment/index.html',
    // 納品書印刷
    shipmentPrint:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/shipment/shipment_print.html'
        : '/shipment/shipment_print.html',
    // 現品票印刷
    shipmentSlipPrint:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/shipment/slip_print.html'
        : '/shipment/slip_print.html',
    // 請求一覧
    billList:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/bill/index.html'
        : '/bill/index.html',
    // 請求書印刷
    billPrint:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/bill/bill_print.html'
        : '/bill/bill_print.html',
    // 売上／原価分析
    purchaseAnalysis:
      process.env.NODE_ENV !== 'development'
        ? '/purchase/analysis/index.html'
        : '/analysis/index.html',

    // for scheduler-inventory repository

    // 在庫一覧
    inventory:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/inventory/index.html'
        : '/inventory/index.html',
    // ロット一覧
    lot:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/lot/index.html'
        : '/lot/index.html',
    // 工程仕掛一覧
    wipProcess:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/wip_process/index.html'
        : '/wip_process/index.html',
    // 出庫スケジュール
    ship:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/leave/index.html'
        : '/leave/index.html',
    // 補充スケジュール
    supply:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/refill/index.html'
        : '/refill/index.html',
    // 在庫分析
    analistics:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/analistics/index.html'
        : '/analistics/index.html',
    // 在庫分析 - 時系列分析
    inventoryAnalysis:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/analysis/index.html'
        : '/analysis/index.html',
    // 在庫分析 - 履歴
    inventoryAnalysisHistory:
      process.env.NODE_ENV !== 'development'
        ? '/inventory/analysis/history.html'
        : '/analysis/history.html',

    // for scheduler-smalllot repository

    // 案件一覧
    orderList:
      process.env.NODE_ENV !== 'development'
        ? '/smlot/order/list.html'
        : '/order/list.html',
    // 外注工程管理
    vendorList:
      process.env.NODE_ENV !== 'development'
        ? '/smlot/order/vendor/list.html'
        : '/order/vendor/list.html',
    // 案件別スケジュール
    scheduleOrder:
      process.env.NODE_ENV !== 'development'
        ? '/smlot/schedule/process/index.html'
        : '/schedule/process/index.html',
    // 外注工程スケジュール
    scheduleVendor:
      process.env.NODE_ENV !== 'development'
        ? '/smlot/order/vendor/index.html'
        : '/order/vendor/index.html',
    // 出荷一覧
    shipList:
      process.env.NODE_ENV !== 'development'
        ? '/smlot/order/ship/list.html'
        : '/order/ship/list.html',
    // ランキング分析
    analyticsRanking:
      process.env.NODE_ENV !== 'development'
        ? '/smlot/analytics/ranking/index.html'
        : '/analytics/ranking/index.html',
  },
  processDisplayColors: {
    pink: { name: '桃色', val: '#ff3366' },
    purple: { name: '紫色', val: '#9966cc' },
    'navy-blue': { name: '紺色', val: '#3366cc' },
    blue: { name: '青色', val: '#0099ff' },
    'light-blue': { name: '水色', val: '#3399cc' },
    'blue-green': { name: '碧色', val: '#009999' },
    green: { name: '緑色', val: '#339900' },
    grass: { name: '草色', val: '#99cc33' },
    yuzu: { name: '柚色', val: '#cccc33' },
    yellow: { name: '黄色', val: '#ffcc00' },
    orange: { name: '橙色', val: '#ff9933' },
    vermilion: { name: '朱色', val: '#ff6633' },
  },
  userDisplayColors: {
    pink: { name: '桃色', val: '#ff3366' },
    purple: { name: '紫色', val: '#9966cc' },
    'navy-blue': { name: '紺色', val: '#3366cc' },
    blue: { name: '青色', val: '#0099ff' },
    'light-blue': { name: '水色', val: '#3399cc' },
    'blue-green': { name: '碧色', val: '#009999' },
    green: { name: '緑色', val: '#339900' },
    grass: { name: '草色', val: '#99cc33' },
    yuzu: { name: '柚色', val: '#cccc33' },
    yellow: { name: '黄色', val: '#ffcc00' },
    orange: { name: '橙色', val: '#ff9933' },
    vermilion: { name: '朱色', val: '#ff6633' },
  },
  tooltipMessages: {
    setDidplayColorOnGanttChart: 'のガントチャート上の表示色を設定します',
  },
  /** サービスID */
  serviceID: {
    /** 受発注管理 */
    purchase: '1',
    /** 在庫管理 */
    inventory: '2',
    /** 工程管理 */
    smallLot: '3',
    /** 各種設定 */
    base: '4',
  },
  /** ローカルストレージのキー名 */
  localStorageKeys: {
    /** サービスID */
    serviceID: 'serviceID',
    /** ロケーションの履歴 */
    locationHistory: 'locationHistory',
    /** サイドバーが展開されているか */
    isSidebarOpen: 'isSidebarOpen',
  },
}
